const IGNORED_ERROR_MESSAGES = [
  "CanceledError: canceled",
  "canceled",
  "AxiosError: Network Error",
  "AxiosError: Request failed with status code 404",
  "AxiosError: Request aborted",
  "TypeError: NetworkError when attempting to fetch resource",
  "Load failed",
  "wB is not defined",
  "Cannot read properties of null (reading 'parentElement')",
  "The media resource indicated by the src attribute or assigned media provider object was not suitable.",
];

const ERROR_STRING_PATTERNS = [
  "Failed to fetch",
  "FetchError",
  "Script error",
  "NetworkError",
  "Network Error",
  "[helpers/providers/hlsjs]",
  "XHR error",
  "[helpers/jwplayer/api/core-shim]: JW Player Error",
  '[helpers/jwplayer/api/core-shim]: "[MediaError]"',
  "ResizeObserver loop completed with undelivered notifications",
  "Cannot resolve a Slate point from DOM point",
  "The play() request was interrupted",
  "Invariant failed",
  "signal is aborted without reason",
  "Ignored attempt to cancel a touchmove event with cancelable=false, for example because scrolling is in progress and cannot be interrupted",
  "The operation was aborted",
  "The fetching process for the media resource was aborted by the user agent at the user's request",
  "Object Not Found Matching Id",
  '{"statusCode":401,"error":"Unauthorized","message":"Expired token","attributes":{"error":"Expired token"}}',
  '{"statusCode":401,"error":"Unauthorized","message":"Missing authentication"}',
  "The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission",
  "Maximum call stack size exceeded",
];

const isFailedRequest = (context, event) => {
  return context?.isAborted || (event?.error && event?.http?.status_code === 0);
};

const isAbortError = (event) => {
  if (!event?.message || typeof event?.message !== "string") return false;
  return event?.message?.includes("AbortError") || event?.type === "AbortError";
};

const isNetworkErrorObject = (event) => {
  if (!event?.message || typeof event?.message !== "object") return false;
  return event?.message?.code === "ERR_NETWORK";
};

const isKnownIgnoredError = (event) => {
  if (!event?.message || typeof event?.message !== "string") return false;
  return IGNORED_ERROR_MESSAGES.includes(event?.message);
};

const isMatchingErrorString = (event) => {
  if (!event?.message || typeof event?.message !== "string") return false;
  return ERROR_STRING_PATTERNS.some((pattern) => event.message.toLowerCase().includes(pattern.toLowerCase()));
};

const setEventTypeToInfo = (event) => {
  event.status = "info";
};

export const shouldSendLog =
  (type = "log") =>
  (event, context) => {
    if (isFailedRequest(context, event)) {
      if (type === "rum") {
        return false;
      }
      // For logs, set type to info
      setEventTypeToInfo(event);
      return true;
    }

    // For RUM errors, event.error contains the actual error object
    // For logs, the event itself contains the error information
    const finalEvent = type === "log" ? event : event?.error;

    if (
      isKnownIgnoredError(finalEvent) ||
      isAbortError(finalEvent) ||
      isMatchingErrorString(finalEvent) ||
      isNetworkErrorObject(finalEvent)
    ) {
      if (type === "rum") {
        return false;
      }
      // For logs, set type to info
      setEventTypeToInfo(event);
      return true;
    }

    return true;
  };
